
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Thirtifivedeater() {



    const cardData =
    {
        keyword: '35 Seater AC Bharat Benz Hire in Pune',
        heading: 'Amruta Travels: 35 Seater AC Bharat Benz Hire in Pune',
        headingDescription: 'Amruta Travels offers 35 Seater AC BharatBenz Bus on Hire in Pune, delivering a perfect blend of comfort, luxury, and performance for medium-sized group travel. Whether you are organizing a corporate outing, educational tour, family function, or a spiritual journey, our 35-seater air-conditioned BharatBenz buses are designed to meet all your travel needs with class and convenience.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',



"topPlaces": [
  {
    "title": "Mahabaleshwar",
    "description": "Located around 120 km from Pune, Mahabaleshwar is a scenic hill station famous for its strawberry farms, lush valleys, and viewpoints like Arthur’s Seat and Wilson Point. It's an ideal spot for nature lovers and weekend getaways."
  },
  {
    "title": "Lonavala & Khandala",
    "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range are popular for their green valleys, monsoon waterfalls, and attractions like Bhushi Dam and Tiger’s Leap. Great for a quick escape from city life."
  },
  {
    "title": "Shirdi",
    "description": "About 190 km from Pune, Shirdi is a major pilgrimage town dedicated to Sai Baba. The Sai Baba Temple attracts millions of devotees annually. The spiritual atmosphere makes it perfect for religious tourism."
  },
  {
    "title": "Goa",
    "description": "Located nearly 450 km from Pune, Goa is the ultimate beach holiday destination. From vibrant nightlife and water sports to heritage forts and churches, Goa offers something for every traveler."
  },
  {
    "title": "Nashik",
    "description": "Around 210 km from Pune, Nashik is known for its religious significance and as India’s wine capital. Key attractions include the Kalaram Temple, Sula Vineyards, and Trimbakeshwar Temple."
  },
  {
    "title": "Alibaug",
    "description": "Situated 140 km away, Alibaug is a coastal town with serene beaches like Nagaon and historical forts such as Kolaba Fort. It’s a popular choice for beach lovers and family picnics."
  },
  {
    "title": "Kolhapur",
    "description": "Roughly 235 km from Pune, Kolhapur is home to the famous Mahalaxmi Temple and is known for its rich cultural heritage and spicy cuisine. It also offers attractions like Rankala Lake and Panhala Fort."
  },
  {
    "title": "Lavasa",
    "description": "Just 60 km from Pune, Lavasa is a planned city nestled in the Western Ghats, offering lakeside views, water sports, and a peaceful retreat. Perfect for a one-day outing or weekend stay."
  },
  {
    "title": "Satara & Kaas Plateau",
    "description": "About 120 km from Pune, Satara is a gateway to the Kaas Plateau, a UNESCO-listed biodiversity hotspot. Visit during the monsoon to witness a stunning bloom of wildflowers across the valley."
  },
  {
    "title": "Aurangabad",
    "description": "Situated 235 km from Pune, Aurangabad is known for the Ajanta and Ellora Caves (UNESCO World Heritage Sites), Bibi Ka Maqbara, and Daulatabad Fort. A must-visit for history and architecture enthusiasts."
  }
],

  "services": [
    {
      "name": "35 Seater AC Bharat Benz on Rent",
      "description": "Amruta Travels offers 35-seater AC Bharat Benz buses for rent, ideal for group travel. Our buses provide luxury, comfort, and reliability for corporate events, weddings, and other occasions."
    },
    {
      "name": "Rent 35 Seater Bharat Benz in Pune",
      "description": "Rent a 35-seater AC Bharat Benz bus in Pune from Amruta Travels. Designed for comfort and efficiency, these buses are perfect for your travel needs, whether it's for corporate tours, weddings, or group outings."
    },
    {
      "name": "35 Seater Bharat Benz Bus Rental Pune",
      "description": "Amruta Travels offers 35-seater Bharat Benz buses for rental in Pune. With spacious seating, air-conditioning, and experienced drivers, our buses ensure a comfortable and enjoyable journey for any event."
    },
    {
      "name": "35 Seater Bharat Benz on Rent for Corporate Event",
      "description": "For corporate events, rent a 35-seater Bharat Benz bus. Our buses are well-equipped with modern amenities, offering a comfortable and reliable travel solution for your team or clients."
    },
    {
      "name": "35 Seater Bharat Benz for Wedding",
      "description": "Make your wedding transportation smooth and luxurious with a 35-seater Bharat Benz bus. Amruta Travels provides stylish, comfortable buses for weddings, ensuring your guests travel in style."
    }
  ],
  "tableData": [
    ["35 Seater AC Bharat Benz on Rent", "Rent 35 Seater Bharat Benz in Pune"],
    ["35 Seater Bharat Benz Bus Rental Pune", "35 Seater Bharat Benz on Rent for Corporate Event"],
    ["35 Seater Bharat Benz for Wedding"]
  ],



"whychoose": [
  {
    "WhyChooseheading": "Luxury Travel with 35 Seater AC Bharat Benz Hire in Pune",
    "WhyChoosedescription": "Amruta Travels offers 35 Seater AC Bharat Benz buses for hire in Pune, providing an extraordinary travel experience for medium-sized groups. Whether you're planning a corporate event, a family outing, or a long-distance trip, these buses combine luxury, comfort, and performance for an unforgettable journey."
  },
  {
    "WhyChooseheading": "Perfect for Corporate Events, Family Gatherings, and Group Tours",
    "WhyChoosedescription": "Our 35 Seater AC Bharat Benz buses are ideal for transporting groups for corporate meetings, weddings, family vacations, or educational tours. With ample space, modern amenities, and high-end features, your entire group will enjoy a comfortable and stylish ride."
  },
  {
    "WhyChooseheading": "State-of-the-Art Features for Ultimate Comfort",
    "WhyChoosedescription": "The 35 Seater AC Bharat Benz buses come equipped with plush seating, advanced air conditioning, individual USB charging ports, entertainment systems, and spacious luggage compartments. These features ensure that passengers can relax and enjoy their journey in maximum comfort."
  },
  {
    "WhyChooseheading": "Affordable Luxury with Transparent Pricing",
    "WhyChoosedescription": "Amruta Travels provides competitive and transparent pricing for 35 Seater AC Bharat Benz bus hires in Pune. Our all-inclusive rates cover fuel, tolls, driver charges, and taxes with no hidden fees, making it easy to budget your trip without any surprises."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers for Safe Travel",
    "WhyChoosedescription": "Our 35 Seater AC Bharat Benz buses are driven by professional, experienced drivers who ensure safety, punctuality, and customer satisfaction. Well-versed in local and outstation routes, they provide smooth and efficient transportation for your group."
  },
  {
    "WhyChooseheading": "Ideal for Local and Long-Distance Travel",
    "WhyChoosedescription": "Whether you need a bus for a short city tour, a family outing to nearby destinations, or a long-distance journey to places like Shirdi, Goa, or Mahabaleshwar, our 35 Seater AC Bharat Benz buses provide the perfect blend of comfort, performance, and style for every kind of trip."
  },
  {
    "WhyChooseheading": "Well-Maintained Fleet for Reliable Travel",
    "WhyChoosedescription": "Our fleet of 35 Seater AC Bharat Benz buses is regularly inspected and well-maintained to ensure smooth, safe, and comfortable journeys. Rest assured that every bus is road-ready, providing you with a hassle-free travel experience."
  },
  {
    "WhyChooseheading": "Seamless Booking Process and 24/7 Customer Support",
    "WhyChoosedescription": "Booking a 35 Seater AC Bharat Benz bus with Amruta Travels is quick and easy. You can book online, over the phone, or in person at our office. Our 24/7 customer support team is available to assist with your bookings, itinerary changes, or any special requests."
  }
]




















    }

const faqData = [
  {
    question: 'Can I hire a 35-seater AC Bharat Benz bus in Pune with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers 35-seater AC Bharat Benz buses for hire in Pune. These buses are perfect for medium-sized groups, corporate events, family functions, school trips, and outstation tours.',
  },
  {
    question: 'What features are available in the 35-seater AC Bharat Benz bus?',
    answer: 'Our 35-seater AC Bharat Benz buses come with luxurious features such as comfortable push-back seats, air conditioning, spacious interiors, large windows for scenic views, reading lights, and ample luggage space for a relaxed and enjoyable journey.',
  },
  {
    question: 'Is the 35-seater AC Bharat Benz available for both local and outstation trips?',
    answer: 'Yes, you can hire the 35-seater AC Bharat Benz bus for both local travel within Pune and outstation trips to destinations like Lonavala, Shirdi, Mahabaleshwar, and Goa.',
  },
  {
    question: 'Does the rental include a driver?',
    answer: 'Yes, all our 35-seater AC Bharat Benz hires include a professional and licensed driver who ensures the safety, comfort, and timely arrival of your group during the entire journey.',
  },
  {
    question: 'How much does it cost to hire a 35-seater AC Bharat Benz in Pune?',
    answer: 'The rental cost depends on factors like trip duration, distance, and type of trip. Typically, rates start from ₹35–₹42 per km. For a customized quote, please reach out to us with your travel details.',
  },
  {
    question: 'Is the 35-seater AC Bharat Benz bus suitable for long-distance travel?',
    answer: 'Yes, the 35-seater AC Bharat Benz is designed for both short and long-distance journeys, offering a comfortable and smooth ride for your group during extended trips.',
  },
  {
    question: 'Are the 35-seater AC Bharat Benz buses well-maintained and sanitized?',
    answer: 'Yes, all our buses, including the 35-seater AC Bharat Benz, are regularly maintained and sanitized before every trip to ensure the highest standards of hygiene, safety, and comfort for our passengers.',
  },
  {
    question: 'How can I hire a 35-seater AC Bharat Benz in Pune?',
    answer: 'You can easily hire the 35-seater AC Bharat Benz bus by booking through our website or contacting our customer service team. We offer hassle-free booking and assistance tailored to your travel needs.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Ashok Patil',
    role: 'Event Coordinator, Pune',
    text: 'We hired a 35-seater AC Bharat Benz bus for our corporate event, and the experience was excellent. The bus was clean, comfortable, and the driver was very professional. Highly recommend Amruta Travels!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Geeta Sharma',
    role: 'School Principal',
    text: 'Amruta Travels provided a 35-seater AC Bharat Benz bus for a school field trip. The bus was spacious, comfortable, and the driver ensured the safety of the students. We had a wonderful experience!',
    rating: 5,
  },
];





















































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];






const acBharatBenz35SeaterSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "35 Seater AC Bharat Benz on Rent in Pune",
  "image": "https://bushireinpune.com/assets/images/35-seater-ac-bharat-benz.jpg", // Update with actual image URL
  "description": "Rent a 35-seater AC Bharat Benz bus in Pune for corporate events, weddings, picnics, and group travel. Experience luxury and comfort with our premium bus rental services.",
  "provider": {
    "@type": "Organization",
    "name": "Amruta Travels",
    "url": "https://bushireinpune.com"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "95"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "14000", // Adjust price based on service details
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/35-seater-ac-bharat-benz-on-rent-in-pune"
  }
};




    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | 35 Seater AC Bharat Benz on Rent in Pune | Corporate & Wedding Bus Rental</title>
  <meta 
    name="description" 
    content="Rent a 35-seater AC Bharat Benz bus in Pune for corporate events, weddings, picnics, and group travel. Luxury bus rental service with air-conditioning for comfort and style." 
  />
  <script type="application/ld+json">
    {JSON.stringify(acBharatBenz35SeaterSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/18.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Thirtifivedeater;